import { Box, Button, Drawer, ListItemButton, Logo } from "./NavBar.style";
import { MODALS } from "../../config/params";

import AppBar from "@mui/material/AppBar";
import Container from "@mui/material/Container";
import { DrawerHeader } from "../DrawerGeneric/DrawerGeneric.style";
import IconButton from "@mui/material/IconButton";
import List from "@mui/material/List";
import ListItemIcon from "@mui/material/ListItemIcon";
import ListItemText from "@mui/material/ListItemText";
import { MENU_ITEMS } from "../LayoutApp/LayoutApp";
import MenuIcon from "../Icons/MenuIcon";
import MenuIconOpened from "../Icons/MenuIconOpened";
import { NavLink, useLocation } from "react-router-dom";
import React from "react";
import { useDrawer } from "../../context/DrawerContext";
import { useGTM } from "../../hooks/useGTM";
import { useModal } from "../../context/ModalContext";
import HomeHospitalIndicator from "../HomeHospitalIndicator/HomeHospitalIndicator";
import { useUserDetail } from "../../services/user-detail/user-detail.service";
import { useOverdueInvoiceStore } from "../../hooks/redux-hooks/overdue-invoice-store/overdue-invoice.store";
import CustomerSupportButton from "../CustomerSupportButton/CustomerSupportButton";

const NavBar = () => {
  const [open, setOpen] = React.useState(false);
  const { closeDrawer } = useDrawer();
  const { user } = useUserDetail();
  const { dispatchEvent } = useGTM();
  const { openModal } = useModal();
  const { pendingPaymentPetList, isBookingBlocked, pausedWellnessPetList, cancelledWellnessPetList }=
  useOverdueInvoiceStore();
  const location = useLocation();

  const handleDrawerOpen = () => {
    setOpen(true);
  };

  const handleDrawerClose = () => {
    setOpen(false);
  };

  const handleGoToBookAVisit = () => {
    if (!isBookingBlocked && (pendingPaymentPetList.length > 0)) {
      if (cancelledWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_CANCELLED_ALERT_MODAL);
      } else if (pausedWellnessPetList.length > 0) {
        openModal(MODALS.PENDING_INVOICE_PAUSED_ALERT_MODAL);
      } else {
        openModal(MODALS.GENERIC_PAYMENT_ISSUE_MODAL);
      }
    } else {
      openModal(MODALS.UPDATED_BOOK_A_VISIT_MODAL);
    }
    setOpen(false);
    dispatchEvent({
      eventName: "gv_book_a_visit_button_mobile",
    });
  };

  return (
    <Container className="mt-[1rem]">
      <Box>
        <AppBar className="mt-[-0.3rem]">
          <Logo>
            <img src="/assets/icons/logo_black.svg" alt="GoodVets" width={150} />
          </Logo>
          <IconButton sx={{ p: 0 }} onClick={handleDrawerOpen}>
            <MenuIcon />
          </IconButton>
        </AppBar>
        <Drawer variant="temporary" anchor="right" open={open}>
          <div className="flex flex-col justify-between h-full pb-2">
            <div>
              <DrawerHeader>
                <IconButton onClick={handleDrawerClose}>
                  <MenuIconOpened />
                </IconButton>
              </DrawerHeader>

              <List>
                {MENU_ITEMS.map((item, index) => {
                  const isActive = location.pathname === item.to;

                  return (
                    <NavLink
                      key={index}
                      to={item.to as string}
                      onClick={() => {
                        setOpen(false);
                        closeDrawer();
                      }}
                      className={({ isActive }) => (isActive ? "active" : "")}
                    >
                      <ListItemButton sx={{ padding: ".7rem 1.5rem" }}>
                        <ListItemIcon color="">{isActive ? item.activeIcon : item.icon}</ListItemIcon>
                        <ListItemText
                          primary={item.label}
                          sx={{ transform: "translateX(-1rem)" }}
                        />
                      </ListItemButton>
                    </NavLink>
                  );
                })}
              </List>
            </div>

            <div>
              <div className="mb-1.5">
                <HomeHospitalIndicator isOpenSideBar={open} user={user} />
              </div>
              <div className="flex items-center justify-center gap-2 px-4">
                <Button
                  id="bookVisitButton"
                  color="primary"
                  size="small"
                  disabled={isBookingBlocked}
                  sx={{
                    display: "grid",
                    placeItems: "center",
                    padding: "0 1.5rem",
                    flex: 1,
                  }}
                  onClick={handleGoToBookAVisit}
                  className="!normal-case"
                >
                    Book Appointment
                </Button>
                <CustomerSupportButton variant="round" onClick={handleDrawerClose} />
              </div>
            </div>
          </div>
        </Drawer>
      </Box>
    </Container>
  );
};

export default NavBar;
